<template>
  <div id="basic_em">
    <div class="top_div_em">
      <el-form :inline="true" :model="formInline">
        <el-form-item label="选择门店">
          <el-select v-model="formInline.shop_id" placeholder="请选择" @change="getTableData">
            <el-option
              v-for="index in typeDate"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
          <!-- <el-form-item style="min-width: 150px; margin-left: 20px;">
              <el-button type="primary" style="background: #1890ff;" @click="onSubmit">查询</el-button>
              <el-button type="primary" class="vubutton" @click="onSubmit">重置</el-button>
          </el-form-item>-->
        </el-form-item>
        <!-- <div class="demo-form-inline_em">
          <el-form-item label="姓名">
            <el-input v-model="formInline.employee_name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="职位">
            <el-select v-model="formInline.id" placeholder="请选择">
              <el-option
                v-for="(item) in listPositions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="在职状态">
            <el-select v-model="formInline.status_code" placeholder="请选择">
              <el-option
                v-for="(item) in listStatus"
                :key="item.key_name"
                :label="item.name"
                :value="item.key_name"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item style="min-width: 150px;">
          <el-button type="primary" style="background: #1890ff;" @click="onSubmits">查询</el-button>
          <el-button type="primary" class="vubutton" @click="onSubmit">重置</el-button>
        </el-form-item>-->
      </el-form>
      <el-button
        type="primary"
        style="background: #1890ff; margin-bottom: 20px;"
        @click="topinsert(false)"
      >
        <i class="el-icon-plus" style="margin-right: 10px;"></i>
        新建
      </el-button>
      <el-table
        :fit="false"
        border
        :data="tableData"
        style="width: auto;"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
        v-loading="dataloading"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="姓名" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别" width="180">
          <template slot-scope="scope">
            <span>{{scope.row.gender}}</span>
          </template>
        </el-table-column>
        <el-table-column label="头像" width="180">
          <template slot-scope="scope">
            <img :src="scope.row.image||$userList.image_url + '/avatar.png'" style="width:30px;height:30px" />
          </template>
        </el-table-column>
          <el-table-column label="性别" width="180">
          <template slot-scope="scope">
            <span>{{scope.row.card}}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="职位" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.position }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="topdetail(scope.row)">查看</el-button>
            <el-button size="mini" @click="topinsert(scope.row)">编辑</el-button>
            <el-button size="mini" @click="detail(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageSize"
        class="pagination_em"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="20"

      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'employee',
  data() {
    return {
      formInline: {
        employee_name: '',
        id: '',
        status_code: '',
        shop_id: '',
      },
      tableData: [],
      typeDate: [],
      listloading: false,
      dataloading: false,
      typeList: [],
      listPositions: [],
      listStatus: [],
      page_no: 1,
      total: 0,
    };
  },
  methods: {
    onSubmit() {
      this.formInline = {
        employee_name: '',
        id: '',
        status_code: '',
      };
      this.page_no = 1;
      this.getTableData();
    },
    onSubmits() {
      this.page_no = 1;
      this.getTableData(true);
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },

    getTableData() {
      this.dataloading = true;
      let data = {};
      const url =
        this.$userList.user_status_employees +
        '/' +
        this.page_no +
        '/' +
        20 +
        '?shop_id=' +
        this.formInline.shop_id;
      this.$http.get(url).then(res => {
        this.dataloading = false;
        if (res.code === 200) {
          this.total = res.data.count;
          this.tableData = res.data.items;
          console.log(res.data);
        } else {
          ////res.message && this.$alert(res.message);
        }
      });
    },
    getPositions() {
      const url = this.$userList.user_common_data + `/employee_position`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.listPositions = res.data.map(item => {
            item.name = item.value;
            return item;
          });
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    getStatus() {
      // this.listloading = true;
      const url = this.$userList.user_common_data + `/employee_status`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.listStatus = res.data.map(item => {
            item.name = item.value;
            return item;
          });
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    pageSize(index) {
      this.page_no = index;
      this.getTableData();
      console.log(index);
    },
    topinsert(value) {
      console.log(!value);
      if (!value) {
        this.$router.push({
          path: '/shop/employee/insert' + '?shop_id=' + this.formInline.shop_id,
        });
        return;
      }
      this.$router.push({
        path:
          '/shop/employee/insert/' +
          value.id +
          '?shop_id=' +
          this.formInline.shop_id,
      });
    },
    topdetail(value) {
      this.$router.push({
        path:
          '/shop/employee/detail/' +
          value.id +
          '?shop_id=' +
          this.formInline.shop_id,
      });
    },
    getList() {
      const url = this.$userList.user_restaurant_list + `/${this.page_no}/20`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          console.log(res);
          this.typeDate = res.data.items;
          this.formInline.shop_id = this.typeDate[0].id;
          this.getTableData();
        } else {
          //res.message && this.$alert(res.message);
        }
      });
    },
    detail(id) {
      console.log(id)
      if (!id) {
        return;
      }
      this.$confirm('此操作将删除人员, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const url = this.$userList.user_semployee_new + '/' + id;
        this.$http.delete(url).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.getTableData();
          } else {
            res.message && this.$alert(res.message);
          }
          console.log(res);
        });
      });
    },
  },
  created() {
    this.$root.setheadName();
    this.getPositions();
    this.getStatus();
    this.getList();
  },
};
</script>

<style >
#basic_em {
  width: 100%;
  height: auto;
  position: relative;
}
.top_div_em {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}
.demo-form-inline_em {
  display: flex;
  justify-content: flex-start;
}

.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
}
.el-button--primary:hover,
.el-button--primary:active,
.el-button--primary:focus {
  background: #1890ff;
  border-color: #1890ff;
}
.el-table--group::after,
.el-table--border::after,
.el-table::before {
  background: none;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}

.name_listem {
  flex: 1;
  height: 100%;
  border-right: solid 1px rgba(0, 0, 0, 0.5);
  text-align: center;
  font-size: 20px;
}

.name_color_em {
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
}
.pagination_em {
  position: relative;
  /* left: 50%; */
  margin-top: 20px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1890ff;
  color: #fff;
}
.el-pagination.is-background .el-pager li.active {
  color: #fff;
  cursor: default;
}
.el-pagination.is-background .el-pager li:hover {
  color: #1890ff;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #1890ff;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: #1890ff;
  color: #fff;
}
</style>
